<script>
import LoadOnDemand from 'comp/modules/LoadOnDemand.vue'
import DialogModules from 'comp/modules/DialogModules'

import { mapGetters } from 'vuex'
import { getNewPage12 } from '@/api/pageData'
import { themeConfigureImgUrl } from '@/utils/common'

export default {
  components: { LoadOnDemand, DialogModules },
  data() {
    return {
      currentCommunity: localStorage.getItem('currentCommunity'),
      imgsList: [],
      pageData: [],
      currentModule: {},
      currentModuleItemDataId: 0,
      currentModuleItemDataHeadline: '',

      currentNavObj2: {
        areaId: 110,
        arrayId: '58,59,60,61',
        id: 655,
        pageBg: require('imgs/pageBg/newPage12/view-bg-id12.png'),
        pageBgId: 12,
        path: '/newPage12',
        sortNumber: 12,
        templateName: '新增模板12',
        titleBg: require('imgs/pageBg/newPage12/title-id12.png'),
        titleLogo: ''
      },
      pageData2: [{
        list: [
          {
            id: 62,
            list: [
              {
                id: 1,
                name: '雨裁1',
                post: '县委书记',
                phone: '17581720221',
                memo: '2022年8月16日至17日，中共中央总书记、国家主，中共中央总书',
                photo: ''
              }, {
                id: 2,
                name: '雨裁2',
                post: '县委书记',
                phone: '17581720221',
                memo: '2022年8月16日至17日，中共中央总书记、国家主，中共中央总书',
                photo: ''
              }, {
                id: 3,
                name: '雨裁3',
                post: '县委书记',
                phone: '17581720221',
                memo: '2022年8月16日至17日，中共中央总书记、国家主，中共中央总书',
                photo: ''
              }, {
                id: 4,
                name: '雨裁4',
                post: '县委书记',
                phone: '17581720221',
                memo: '2022年8月16日至17日，中共中央总书记、国家主，中共中央总书',
                photo: ''
              }
            ],
            subtitle: null,
            title: '测试组件62',
            titleid: 3328,
            type: '横1/2组件',
            typeid: 0
          }
        ]
      }, {
        list: [
          {
            id: 63,
            list: [
              {
                id: 1,
                name: '雨裁1',
                memo: '家庭是社会的基本细胞，是人生的第一所学校。不论时代发生多大变化，不论生活格局发生多大变化，我们都要重视家庭建设，注重家庭、注重家教、注重家风家庭是社会的基本细胞，是人生的第一所学校。不论时代发生多大变化，不论生活格局发生多大变化，我们都要重视家庭建设，注重家庭、注重家教、注重家风'
              }, {
                id: 2,
                name: '雨裁2',
                memo: '家庭是社会的基本细胞，是人生的第一所学校。不论时代发生多大变化，不论生活格局发生多大变化，我们都要重视家庭建设，注重家庭、注重家教、注重家风'
              }, {
                id: 3,
                name: '雨裁3',
                memo: '家庭是社会的基本细胞，是人生的第一所学校。不论时代发生多大变化，不论生活格局发生多大变化，我们都要重视家庭建设，注重家庭、注重家教、注重家风'
              }
            ],
            subtitle: null,
            title: '测试组件63',
            titleid: 3329,
            type: '横1/2组件',
            typeid: 0
          }
        ]
      }, {
        list: [
          {
            id: 64,
            list: [
              {
                headline: '测试标题测试标题测试标题1',
                memo: '<p>测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1</p>'
              }, {
                headline: '测试标题2',
                memo: '<p>测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1测试内容测试内容测试内容测试内容测试内容测试内容1</p>'
              }
            ],
            subtitle: null,
            title: '测试组件64',
            titleid: 3327,
            type: '横1/2组件',
            typeid: 1
          }
        ]
      }, {
        list: [
          {
            id: 65,
            list: [
              {
                id: 1,
                headline: '中共中央总书记、国家主席中共中央总书记、国家主席中共中央总书记、国家主席',
                typeid: 1,
                memo: '<p>2022年8月16日至17日，中共中央总书记、国家主，中共中央总书2022年8月16日至17日，中共中央总书记、国家主，中共中央总书</p>'
              }, {
                id: 2,
                headline: '中共中央总书记、国家主席',
                typeid: 1,
                memo: '<p>2022年8月16日至17日，中共中央总书记、国家主，中共中央总书</p>'
              }, {
                id: 3,
                headline: '中共中央总书记、国家主席',
                typeid: 3,
                typename: '社区森林火灾应急处置办法.doc'
              }
            ],
            subtitle: null,
            title: '测试组件65',
            titleid: 3328,
            type: '横1/3组件',
            typeid: 0
          }
        ]
      }, {
        list: [
          {
            id: 66,
            list: [
              {
                headline: '祖国颂',
                name: '群星',
                time: '347000',
                typename: '05祖国颂.mp3',
                status: 1
              }, {
                headline: '当兵的人',
                name: '群星',
                time: '232000',
                typename: '06当兵的人.mp3',
                status: 1
              }, {
                headline: '没有共产党就没有新中国',
                name: '群星',
                time: '114000',
                typename: '02没有共产党就没有新中国.mp3',
                status: 1
              }
            ],
            subtitle: null,
            title: '测试组件66',
            titleid: 3329,
            type: '横1/3组件',
            typeid: 0
          }
        ]
      }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getCurrentNavObj: 'config/getCurrentNavObj',
      currentModalNameGetter: 'config/getCurrentModalName',
      screenSizeGetter: 'config/getScreenSize'
    }),
    currentNavObj() { return this.getCurrentNavObj },
    currentModalName() { return this.currentModalNameGetter },
    currentModalImg() {
      let imgArr = []
      this.imgsList.forEach(item => {
        if (item.title === this.currentModalName) imgArr = item.img
      })
      return imgArr
    },
    screenSize: {
      get() {
        return this.screenSizeGetter
      }
    }
  },
  watch: {
    screenSize(newVal, oldVal) {
      this.$nextTick(() => {
        const enlarge_dom = document.getElementById('pulic-main-content')
        enlarge_dom.style.transform = `scale(${newVal})`
        enlarge_dom.style.transformOrigin = '0 0'
      })
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    themeConfigureImgUrl,
    onCheckDetail(v) {
      this.currentModule = v
      this.$store.commit('config/SET_CURRENT_MODALNAME', v.title)
      this.$store.commit('config/SET_CURRENT_MODULE_ID', v.id)
      const whiteList = [15, 61, 66]
      if (whiteList.includes(v.id)) return
      this.$store.commit('config/SET_DIALOG', true)
    },
    onModuleItem(v) {
      this.currentModuleItemDataId = v?.id || 0
      this.currentModuleItemDataHeadline = v?.headline || ''
    },

    initPageData() {
      const params = {
        village: this.currentCommunity,
        title: this.currentNavObj.templateName,
        userid: localStorage.getItem('screenUserid') || 0,
        tid: this.currentNavObj.id
      }
      getNewPage12(params).then(res => {
        if (res.code === 0) this.pageData = res.msg
      })
    }
  }
}
</script>

<template>
  <!-- background: `url(${themeConfigureImgUrl(currentNavObj2.pageBg)}) no-repeat center`,
      backgroundSize: '100% 100%' -->
  <div
    class="page-used-style new-page10"
    :style="{
      background: `url(${currentNavObj2.pageBg}) no-repeat center`,
      backgroundSize: '100% 100%'
    }"
  >
    <div class="enlarge-box">
      <div id="pulic-main-content" class="pulic-main-content">
        <load-on-demand
          v-for="(v, i) in pageData"
          :key="`load-demand-${i}`"
          :page-data-obj="v.list[0]"
          @click.native="onCheckDetail(v.list[0])"
          @onModuleItem="onModuleItem"
        />
      </div>
    </div>

    <Dialog>
      <template #content-main>
        <dialog-modules
          v-if="currentModalName"
          :current-module="currentModule"
          :current-module-item-data-id="currentModuleItemDataId"
          :current-module-item-data-headline="currentModuleItemDataHeadline"
        />
      </template>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
.new-page10 {
  background-size: 100% 100% !important;
  .pulic-main-content {
    width: 1500px;
    height: 944px;
    overflow-y: scroll;
    padding: 35px 0;
    box-sizing: border-box;
    transition: all .2s ease-in;

    display: flex;
    flex-wrap: wrap;
    column-gap: 65px;
    row-gap: 95px;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
}

.img-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  // row-gap: 40px;
  .modal-img {
    width: 1280px;
    height: auto;
  }
}
</style>
